import createDecorator from 'final-form-focus'
import PropTypes from 'prop-types'
import React from 'react'
import { Form, FormSpy } from 'react-final-form'

import Select from 'components/_form/Select'
import OrderFieldInfo from 'components/_special/OrderFieldInfo'
import { UK } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { MenuMainContext } from 'contexts/MenuMain'
import { ResizeConsumer } from 'contexts/Resize'
import usePersInfoSubmit from 'forms/hooks/usePersInfoSubmit'
import { Col } from 'styles/components/layout'
import { Text } from 'styles/components/typography'
import { scrollToErrorInput } from 'utils/client/scroll'


import PersonalInfo from './PersonalInfo'
import { RowStyled } from './styles'

// Indent for info icon place to call tooltip with hint
const MOBILE_SELECT_RIGHT_INDENT = 40

const focusOnError = createDecorator(undefined, scrollToErrorInput)

const OrderPersInfoEuForm = React.forwardRef((props, ref) => {
  const {
    onChange,
    onSubmit,
    id,
    errorsDict,
    optionsPhoneCode,
    optionsCountry,
    initialValues,
    texts,
    isDisabled,
    deliveryType,
  } = props
  const [initVal] = React.useState(() => initialValues)
  const {
    locale,
    currentCountry: { alpha2Code },
  } = React.useContext(LocalizationContext)
  const { switchLocale } = React.useContext(MenuMainContext)

  const onPersInfoSubmit = usePersInfoSubmit({ onChange, onSubmit })

  return (
    <>
      <Form
        onSubmit={({ values }) => switchLocale(values.country, locale)}
        initialValues={initVal}
        render={() => (
          <form id="country-switcher" ref={ref}>
            <ResizeConsumer>
              {({ mobile, breakpoint }) => (
                <RowStyled>
                  <Col width={{ xs: 1, md: 7 / 12, lg: 1 / 2 }}>
                    <Select
                      autoComplete="country"
                      placeholder={texts.fields.country.title}
                      name="country"
                      options={optionsCountry}
                      isMobile={mobile || breakpoint === ''}
                      isDisabled={true}
                      withRightIndent={mobile ? MOBILE_SELECT_RIGHT_INDENT : 0}
                    />
                    <FormSpy
                      subscribe={{ values: true }}
                      onChange={({ values }) => {
                        switchLocale(values.country, locale)
                      }}
                    />
                  </Col>
                  <OrderFieldInfo>
                    {texts.fields.country.hint &&
                      texts.fields.country.hint_mobile &&
                      locale === UK && (
                        <Text
                          as="span"
                          dangerouslySetInnerHTML={{
                            __html: mobile
                              ? texts.fields.country.hint_mobile
                              : texts.fields.country.hint,
                          }}
                        />
                      )}
                  </OrderFieldInfo>
                </RowStyled>
              )}
            </ResizeConsumer>
          </form>
        )}
      />
      <Form
        onSubmit={onPersInfoSubmit}
        decorators={[focusOnError]}
        initialValues={initVal}
        render={({ handleSubmit, submitting, form: { change, batch } }) => (
          <PersonalInfo
            {...{
              errorsDict,
              id,
              optionsPhoneCode,
              texts,
              onChange,
              isDisabled,
              deliveryType,
              locale,
              alpha2Code,
              handleSubmit,
              batch,
              change,
              submitting,
              ref,
            }}
          />
        )}
      />
    </>
  )
})

OrderPersInfoEuForm.propTypes = {
  errorsDict: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  optionsCountry: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  optionsPhoneCode: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  texts: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  beforeCardContent: PropTypes.node,
  isDisabled: PropTypes.bool,
  deliveryType: PropTypes.number,
}

OrderPersInfoEuForm.defaultProps = {
  isDisabled: false,
}

export default OrderPersInfoEuForm
